export const DEFAULT_CURRENCY_CODE = "USD"
export const CURRENCY_CODE = {
    1: "MXN",
    2: "USD"
}